import React from "react";
import { Typography } from "@material-ui/core";
import DataTable from "@/components/DataTable";
import { ReactRender } from "@/components/ReactRender";
import { useTranslation } from "@/langs/useTranslation";
import { getCMSTemplateHistory } from "@/apis/apiCollection";
import ScheduleTaskRange from "@/containers/Schedule/CreateTemplate/TaskCreator/TaskRange";
import ScheduleType from "@/containers/Schedule/CreateTemplate/TaskCreator/ScheduleType";
import { orderTypeMap } from "@/containers/CMS/TemplateList/CONSTANT";
import dayjs from "dayjs";

export const CmsHistoryListDatatable = React.forwardRef(
  (
    {
      className,
      style,
      getSearchParams,
      footer,
      children,
      onViewDevices,
      onCheckAll,
      onRowClick,
      onLoaded
    },
    ref
  ) => {
    const { t } = useTranslation();

    const columns = [
      {
        data: "name",
        title: t({ defaultMessage: "模板名称" }),
        searchable: false,
        orderable: false
      },
      {
        data: "contentTemplateTypeName",
        title: t({ defaultMessage: "类型" }),
        orderable: false
      },
      {
        data: "version",
        title: t({ defaultMessage: "版本" }),
        render: (data, _, row) => {
          return `${row.versionPrefix}${data}`;
        },
        orderable: false
      },
      {
        data: "name",
        title: t({ defaultMessage: "播放时段" }),
        orderable: false,
        createdCell: (td, data, row) => {
          if (!row.contentTemplateDetail) {
            ReactRender(<Typography variant="body2">-</Typography>, td);
            return;
          }
          const detail = JSON.parse(row.contentTemplateDetail);
          const taskRangeData = {
            json: {
              start_datetime: Number(row.effectBeginTime),
              end_datetime: Number(row.effectEndTime),
              run_times: row.effectType===3? row.effectTimes: 0,
              end_type:
                row.effectType === 1
                  ? "forever"
                  : row.effectType === 2
                  ? "datetime"
                  : "times"
            }
          };
          const typeData = {
            schedule_type: detail.loopMode,
            json: {
              cycle_type:
                detail.loopMode === "weekly" ? "weekly_days" : detail.loopMode,
              cycle_value:
                detail.loopMode === "weekly"
                  ? 1
                  : detail.loopDailyValue === "every_day"
                  ? "every"
                  : detail.loopDailyValue,
              cycle_days: detail.loopModeDays
            }
          };
          ReactRender(
            <div>
              <div>
                <ScheduleTaskRange data={taskRangeData} />
              </div>
              <div>
                <ScheduleType data={typeData} />
              </div>
              <div>
                {(detail.executeTimeRangeInfo || [])
                  .map(
                    v =>
                      `${v.executeBeginTime.hour.toString().padStart(2, '0')}:${v.executeBeginTime.minute.toString().padStart(2, '0')} - ${v.executeEndTime.hour.toString().padStart(2, '0')}:${v.executeEndTime.minute.toString().padStart(2, '0')}`
                  )
                  .join(", ")}
              </div>
            </div>,
            td
          );
        }
      },
      {
        data: "createUserName",
        title: t({ defaultMessage: "创建者" }),
        orderable: false
      },
      {
        data: "effectBeginTime",
        title: t({ defaultMessage: "生效时间" }),
        render: data => {
          return dayjs(Number(data)).format("YYYY/MM/DD HH:mm");
        },
        orderable: false
      },
      {
        data: "installNum",
        orderable: false,
        title: t({ defaultMessage: "已安装设备数量" }),
        className: "center",
        createdCell: (td, data, row) => {
          if (data <= 0) {
            ReactRender(<Typography variant="body2">{data}</Typography>, td);
            return;
          }
          ReactRender(
            <Typography
              variant="body2"
              color="primary"
              component="span"
              style={{ cursor: "pointer" }}
              onClick={e => {
                e.stopPropagation();
                onViewDevices(row, "installNum");
              }}
            >
              {data}
            </Typography>,
            td
          );
        }
      },
      {
        data: "waitInstallNum",
        orderable: false,
        title: t({ defaultMessage: "待安装设备数量" }),
        className: "center",
        createdCell: (td, data, row) => {
          if (data <= 0) {
            ReactRender(<Typography variant="body2">{data}</Typography>, td);
            return;
          }
          ReactRender(
            <Typography
              variant="body2"
              color="primary"
              component="span"
              style={{ cursor: "pointer" }}
              onClick={e => {
                e.stopPropagation();
                onViewDevices(row, "waitInstallNum");
              }}
            >
              {data}
            </Typography>,
            td
          );
        }
      }
    ];

    const ajax = (data, callback) => {
      let orderType;
      let orderWay;
      const order = data.order[0];
      if (order && data.columns[order.column]?.orderable) {
        orderType = orderTypeMap[data.columns[order.column]?.name];
        // orderType = data.columns[order.column]?.name;
        // orderType = order.column;
        orderWay = order.dir === "asc" ? 1 : 2;
      }
      return getCMSTemplateHistory({
        orderType,
        orderWay,
        ...getSearchParams(),
        page: data.page,
        pageSize: data.pageSize
      }).then(res => {
        callback({
          data: res.contentTemplateHistories,
          // draw: data.draw,
          recordsFiltered: res.total,
          recordsTotal: res.total
        });
      });
    };

    return (
      <DataTable
        ref={ref}
        ordering
        options={{ order: [[1, "asc"]] }}
        columns={columns}
        ajax={ajax}
        className={className}
        style={style}
        footer={footer}
        scrollable
        showCheckAll={false}
        onCheckAll={onCheckAll}
        onRowClick={onRowClick}
        onLoaded={onLoaded}
      >
        {children}
      </DataTable>
    );
  }
);
